import React, { PureComponent } from 'react'
import Button from '../Button'
import './index.css'

class ButtonFile extends PureComponent {
  handleClick = () => this.input.click()

  render() {
    const { children, onChange, ...props } = this.props

    return (
      <div className={ 'buttonFile' }>
        <Button
          { ...props }
          types={ ['button--full'] }
          onClick={ this.handleClick }>
          { children }
        </Button>
        <input
          ref={ (input) => this.input = input }
          style={{ display: 'none' }}
          type="file"
          accept="image/gif"
          onChange={ onChange } />
      </div>
    )
  }
}

export default ButtonFile



// WEBPACK FOOTER //
// ./src/components/ButtonFile/index.js